import { render, staticRenderFns } from "./verify-code.vue?vue&type=template&id=23e2a84a&"
import script from "./verify-code.vue?vue&type=script&lang=js&"
export * from "./verify-code.vue?vue&type=script&lang=js&"
import style0 from "./verify-code.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports